// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aIzn","colBig":"styles_colBig__zUKri","colSmall":"styles_colSmall__12g5Q"};